import Firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCL09dknKFlaCR7_2wIWv0w1dVmqSxYbK4",
  authDomain: "lbfx-a9612.firebaseapp.com",
  databaseURL: "https://lbfx-a9612.firebaseio.com",
  projectId: "lbfx-a9612",
  storageBucket: "lbfx-a9612.appspot.com",
  messagingSenderId: "700509938680",
  appId: "1:700509938680:web:a0a5d7129dab143debac0d"
};
  const firebaseApp = Firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.database();